export default {
  props: {
    card: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      // there is predefined steps that user can go throw, but the order can be change from admin
      steps: [],
      nextStep: {},
    }
  },
  computed: {
    profileInfo() {
      return this.$store.state.profile.profileInfo
    },
  },
  watch: {
    '$store.state.auth.steps': {
      handler() {
        const [nextStep] = this.$store.state.auth.steps.filter(step => !step.done_step).sort((a, b) => a.priority - b.priority)
        this.nextStep = nextStep
      },
      deep: true,
    },
  },
}
